import { render, staticRenderFns } from "./DatepickerMonthYearViewOnly.vue?vue&type=template&id=4d6e165a"
import script from "./DatepickerMonthYearViewOnly.vue?vue&type=script&lang=js"
export * from "./DatepickerMonthYearViewOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports